<template>
  <v-row>
		<v-col cols="12">
			<importacoes-bdgd-data-table
        :items="items"
        @rechargeTable="getImportacoes()"
      />
		</v-col>
	</v-row>
</template>

<script>

import ImportacoesBdgdService from '@/services/ImportacoesBdgdService.js';
import tourMixins from '@/mixins/tourMixins';
import pusherMixins from "@/mixins/pusherMixins";

export default {
  mixins: [pusherMixins, tourMixins],

  components: {
    ImportacoesBdgdDataTable: () => import("@/components/importacoesBdgd/ImportacoesBdgdDataTable.vue"),
  },

  data() {
    return {
      items: [],
      arrTour: [
        {
          element: '#btn-nova-importacao-bdgd',
          intro: 'Clicando neste botão você poderá cadastrar novas importações.',
          scrollTo: "tooltip",
          position: 'right'
        },
        {
          element: "#importacoes-bdgd-historico-search",
          intro: "Neste campo você poderá pesquisar por importações já cadastradas.",
          scrollTo: "tooltip",
          position: 'bottom'
        },
        {
          element: '#importacao-bdgd-log-criacao',
          intro: 'Aqui você poderá visualizar informações de criação da importação, como data e horário de registro.',
          scrollTo: "tooltip",
          position: 'left'
        }
      ]
    }
  },

  mounted() {    
    this.getImportacoes();
    this.subscribe();
  },

  methods: {
    subscribe() {
      this.pusherChannel.bind('refresh-importacoes-bdgd-v2', () => {
        this.getImportacoes();
      });
    },
    getImportacoes() {
      ImportacoesBdgdService.getImportacoes()
        .then(res => {
          this.items = [];
          
          res.data.importacoes.forEach(item => {
            this.items.push({
              id: item.id,
              data_registro: item.data_registro,
              versao: item.versao,
              tabelas: JSON.parse(item.entidades),
              numero_linhas: item.registros,
              status: item.status,
              usuario: item.usuario.nome,
              created: item.created
            });
          });
        }).catch(err => {
          console.error(err);
          this.$toast.error("Erro ao recuperar Importações de BDGD", "", { position: "topRight" });
        }).finally(() =>{
          this.iniciarTourPagina();
        });
    },

    iniciarTourPagina() {
      if (this.tourFuncCalled) return;
      let arrTourFormatted = this.items.length ? this.arrTour : this.arrTour.splice(0,2);
      this.iniciarTour(arrTourFormatted);
    }
  },
}
</script>